import { Badge, Button, Container } from "@mantine/core";
import Link from "next/link";
import { useTranslation } from "react-i18next";

import { Card } from "@/components/general/card/card";
import { Section } from "@/components/general/section";
import { SectionTitle } from "@/components/general/section-title/section-title";
import { EscapeRoomCardProps } from "@/components/types";

import styles from "./demo-section.module.css";

export const DemoSection = ({ escapeRooms }: { escapeRooms: EscapeRoomCardProps[] }) => {
    const { t } = useTranslation();
    const demoRoom = escapeRooms.find((room) => room.url === "bar");

    return (
        <Section variant="default" className={styles.section} id="demo">
            <SectionTitle title={t("home.demo.title")} subTitle={t("home.demo.subtitle")} />

            <Container mt="xl" size="100%" className={styles.cardContainer}>
                {demoRoom && (
                    <>
                        <Card title={t("home.demo.title")} description={t("home.demo.description")} className={styles.descriptionBox} />

                        <Card
                            title={demoRoom.title}
                            description={demoRoom.description}
                            difficulty={demoRoom.difficulty}
                            image={demoRoom.image}
                            layout="horizontal"
                            imageBadge={
                                <Badge className={styles.timeBadge} color="var(--color-primary-8)" size="lg">
                                    ~{demoRoom.time} min.
                                </Badge>
                            }>
                            <Button
                                lts=".06rem"
                                radius="md"
                                mt="auto"
                                size="lg"
                                className={styles.playButton}
                                fullWidth
                                component={Link}
                                href={`/details/${demoRoom.url}`}
                                area-label={`${demoRoom.title} – Online Escape Room, ${t("endscreen.difficulty")}: ${demoRoom.difficulty},  ca. ${demoRoom.time} min`}
                                title={`${demoRoom.title} – Online Escape Room, ${t("endscreen.difficulty")} ${demoRoom.difficulty},  ca. ${demoRoom.time} min`}>
                                {t("home.demo.button")}
                            </Button>
                        </Card>
                    </>
                )}
            </Container>
        </Section>
    );
};
